<template>
  <div class="content">
    <div class="md-layout">
      <div class="md-layout-item md-medium-size-100 md-size-75">
        <md-card>
          <md-card-header class="md-card-header-icon md-card-header-primary">
            <div class="card-text">
              <h4 class="title">
                {{ client.name }}
              </h4>
            </div>
          </md-card-header>
          <md-card-content>
            <div class="md-layout">
              <div class="md-layout-item md-small-size-100 md-size-33">
                <address>
                  {{ client.address1 }}
                  <br />
                  <template v-if="client.address2">
                    {{ client.address2 }}
                    <br />
                  </template>
                  <template v-if="client.address3">
                    {{ client.address3 }}
                    <br />
                  </template>
                  <template v-if="client.city">
                    {{ client.city }}
                    <br />
                  </template>
                  <template v-if="client.county">
                    {{ client.county }}
                    <br />
                  </template>
                  <template v-if="client.country">
                    {{ client.country }}
                    <br />
                  </template>
                  {{ client.postcode }}
                </address>
              </div>
            </div>
          </md-card-content>
        </md-card>
        <md-card>
          <md-card-header class="md-card-header-text md-card-header-primary">
            <div class="card-text">
              <h4 class="title">Sites</h4>
            </div>
          </md-card-header>
          <md-card-content>
            <siteList></siteList>
          </md-card-content>
        </md-card>
      </div>
      <div class="md-layout-item md-medium-size-100 md-size-25">
        <md-card>
          <md-card-header class="md-card-header-icon md-card-header-primary">
            <div class="card-icon">
              <md-icon>library_books</md-icon>
            </div>
            <h4 class="title">Reports</h4>
          </md-card-header>
          <md-card-content>
            <div class="md-layout">
              <div class="md-layout-item md-medium-size-100 md-size-100">
                <md-button
                  class="md-primary"
                  @click="onGenerateActivePlantReport()"
                  >Active Plant</md-button
                >
              </div>
            </div>
          </md-card-content>
        </md-card>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import SiteList from "./components/SiteListing";

export default {
  components: {
    SiteList
  },
  computed: {
    ...mapGetters({
      client: "portfolio/client"
    })
  },
  async created() {
    await this.$store.dispatch(
      "portfolio/getClient",
      this.$route.params.clientId
    );
  },
  methods: {
    onGenerateActivePlantReport() {
      this.$store.dispatch("report/getActivePlantReport", {
        clientId: this.$route.params.clientId
      });
    }
  }
};
</script>

<style></style>
